export default __webpack_public_path__ + "static/utas_net_logo-b6640a901b59392e56bf65ff20b6d6bd.svg";